import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { QuoteBuilder } from './quotes/QuoteBuilder';
export function renderQuoteBuilder(elId, orderId) {
    if (process.env.ENVIRONMENT && process.env.ENVIRONMENT !== 'development') {
        Sentry.init({
            dsn: 'https://35276eed929c462ba9b4803069829727@o331845.ingest.sentry.io/6295483',
            environment: process.env.ENVIRONMENT,
            integrations: [Sentry.browserTracingIntegration()],
        });
    }
    const target = document.getElementById(elId);
    const root = createRoot(target);
    root.render(React.createElement(QuoteBuilder, { orderId: orderId }));
}
window.renderQuoteBuilder = renderQuoteBuilder;
